import request from '@/utils/request';
import Resource from '@/api/resource';
class AppManagement extends Resource {
  constructor() {
    super('tool/appManagement/jrtt');
  }

  /** 获取广告主下的渠道包列表 */
  getChannelPackageListApi(data) {
    return request({
      url: `/${this.uri}/channelPackageList`,
      method: 'get',
      params: data,
    });
  }
}
export { AppManagement as default };
